import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generatePartnerPDFReport = (partnerData, summaryStats, fxClients, pammClients) => {
    const doc = new jsPDF('landscape');
    
    // Add Header
    doc.setFontSize(22);
    doc.setTextColor(30, 41, 59);
    doc.text('Partner Network & Commission Report', 14, 22);
    
    // Partner Details
    doc.setFontSize(11);
    doc.setTextColor(100, 116, 139);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);
    
    doc.setFontSize(12);
    doc.setTextColor(15, 23, 42);
    doc.text(`Partner Name: ${partnerData.name || 'N/A'}`, 14, 40);
    doc.text(`Email: ${partnerData.email || 'N/A'}`, 14, 46);
    doc.text(`Wallet Balance: $${(partnerData.wallet_balance || 0).toFixed(2)}`, 14, 52);

    // Summary Box (Right Side)
    doc.text(`Total Active Clients: ${summaryStats.activeClients}`, 200, 40);
    doc.text(`Network Volume (Lots): ${summaryStats.networkVolume}`, 200, 46);
    doc.text(`Total Lifetime Earnings: $${(summaryStats.totalEarnings || 0).toFixed(2)}`, 200, 52);

    let nextY = 65;

    // FX / CFD Table
    if (fxClients && fxClients.length > 0) {
        doc.setFontSize(16);
        doc.setTextColor(15, 23, 42);
        doc.text('FX/CFD Referred Clients', 14, nextY);
        nextY += 10;
        
        const tiers = {};
        fxClients.forEach(c => {
            const t = c.tierLabel || 'Direct';
            if (!tiers[t]) tiers[t] = [];
            tiers[t].push(c);
        });

        Object.keys(tiers).sort().forEach(tier => {
            if (nextY > 170) {
                doc.addPage();
                nextY = 20;
            }
            doc.setFontSize(12);
            doc.setTextColor(37, 99, 235);
            doc.text(`${tier} Clients`, 14, nextY);
            
            const totalDeposit = tiers[tier].reduce((sum, c) => sum + (c.deposit || 0), 0);

            const fxRows = tiers[tier].map(c => [
                c.name || c.email || 'Unknown',
                `$${(c.deposit || 0).toFixed(2)}`,
                `$${(c.live_equity || 0).toFixed(2)}`,
                (Number(c.volume) || 0).toFixed(2),
                `$${(Number(c.rebate_generated) || 0).toFixed(2)}`,
                c.status || 'Active'
            ]);

            fxRows.push([
                { content: 'Total Deposits', styles: { fontStyle: 'bold', halign: 'right' } },
                { content: `$${totalDeposit.toFixed(2)}`, styles: { fontStyle: 'bold' } },
                '', '', '', ''
            ]);

            autoTable(doc, {
                startY: nextY + 5,
                head: [['Name/Email', 'Deposit', 'Live Equity', 'Volume', 'Rebate', 'Status']],
                body: fxRows,
                theme: 'striped',
                headStyles: { fillColor: [37, 99, 235] },
                styles: { fontSize: 9 }
            });
            
            nextY = doc.lastAutoTable.finalY + 15;
        });
    }

    // PAMM Activity Table
    if (pammClients && pammClients.length > 0) {
        if (nextY > 160) {
            doc.addPage();
            nextY = 20;
        }

        doc.setFontSize(16);
        doc.setTextColor(15, 23, 42);
        doc.text('PAMM Activity & Sub-Investors', 14, nextY);
        nextY += 10;
        
        const tiers = {};
        pammClients.forEach(p => {
            const t = p.tierLabel || 'Direct';
            if (!tiers[t]) tiers[t] = [];
            tiers[t].push(p);
        });

        Object.keys(tiers).sort().forEach(tier => {
            if (nextY > 170) {
                doc.addPage();
                nextY = 20;
            }
            doc.setFontSize(12);
            doc.setTextColor(147, 51, 234);
            doc.text(`${tier} PAMM Allocations`, 14, nextY);
            
            const totalDeposit = tiers[tier].reduce((sum, p) => sum + (Number(p.deposit || p.pamm_deposit) || 0), 0);

            const pammRows = tiers[tier].map(p => {
                const rawAlloc = Number(p.allocation_percentage || p.alloc_percentage || 0);
                const dateStr = p.created_at ? new Date(p.created_at).toLocaleDateString() : (p.date || '-');
                return [
                    dateStr,
                    p.name || p.client_email || p.email || 'Unknown',
                    p.pamm_name || p.strategy_name || p.pamm_commission_runs?.strategy_name || '-',
                    rawAlloc ? `${parseFloat(rawAlloc.toFixed(6))}%` : '-',
                    `$${(Number(p.deposit || p.pamm_deposit || p.PammDeposit) || 0).toFixed(2)}`,
                    (Number(p.lots_traded || p.volume || p.pamm_volume || p.PammVolume) || 0).toFixed(2),
                    `$${(Number(p.pamm_rebate || p.PammRebate) || 0).toFixed(2)}`,
                    `$${(Number(p.profit_split || p.ProfitSplit) || 0).toFixed(2)}`
                ];
            });

            pammRows.push([
                '', '', '', 
                { content: 'Total Deposits', styles: { fontStyle: 'bold', halign: 'right' } },
                { content: `$${totalDeposit.toFixed(2)}`, styles: { fontStyle: 'bold' } },
                '', '', ''
            ]);

            autoTable(doc, {
                startY: nextY + 5,
                head: [['Date', 'Client', 'PAMM Strategy', 'Alloc %', 'Deposit', 'Volume', 'Rebate', 'Profit Split']],
                body: pammRows,
                theme: 'striped',
                headStyles: { fillColor: [147, 51, 234] }, // Purple
                styles: { fontSize: 9 }
            });
            
            nextY = doc.lastAutoTable.finalY + 15;
        });
    }

    doc.save(`Nommia_Report_${partnerData.name?.replace(/\s+/g, '_') || 'Partner'}.pdf`);
};
